import { CollectionOrigin, ColorTokenInlineData, ObjectMeta, } from "@supernova-studio/model";
import { z } from "zod";
export const DTOCollectionOrigin = CollectionOrigin.extend({
    /** @deprecated Use `sourceIds` instead. This field will be removed in the future. */
    sourceId: z.string(),
});
export const DTOTokenCollection = z.object({
    id: z.string(),
    persistentId: z.string(),
    designSystemVersionId: z.string(),
    meta: ObjectMeta,
    backgroundColor: ColorTokenInlineData.optional(),
    elementPropertyOptionId: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    parentPersistentId: z.string().optional(),
    origin: DTOCollectionOrigin.optional(),
});
export const DTOTokenCollectionsListReponse = z.object({
    collections: DTOTokenCollection.array(),
});
